// eslint-disable-next-line no-restricted-imports
import { BlockNoteSchema } from "@blocknote/core";
// eslint-disable-next-line no-restricted-imports
import { docxDefaultSchemaMappings, DOCXExporter } from "@blocknote/xl-docx-exporter";
// eslint-disable-next-line no-restricted-imports
import { pdfDefaultSchemaMappings, PDFExporter } from "@blocknote/xl-pdf-exporter";

import {
  stotlesCalloutBlockDocxMapping,
  stotlesCalloutBlockPdfMapping,
  stotlesCalloutBlockSpec,
} from "./custom_blocks/stotlesCalloutBlock";
import { colorsWithCssFallback } from "./cssColorParser";

export const stotlesBlockNoteSchema = BlockNoteSchema.create().extend({
  blockSpecs: {
    // Add your own custom blocks:
    stotlesCallout: stotlesCalloutBlockSpec(),
  },
  // inlineContentSpecs: {
  //   // Add your own custom inline content:
  //   customInlineContent: CustomInlineContent,
  // },
  // styleSpecs: {
  //   // Add your own custom styles:
  //   customStyle: CustomStyle,
  // },
});

// Unfortunately the complex type means it's hard to just export the mappings object and have it
// be correctly typed, so we export the whole exporter instance instead with the mappings already applied
export const StotlesDOCXExporter = new DOCXExporter(
  stotlesBlockNoteSchema,
  {
    blockMapping: {
      ...docxDefaultSchemaMappings.blockMapping,
      // Add custom block mappings here if needed
      stotlesCallout: (block, _exporter, _nestingLevel, _numberedListIndex, _children) =>
        stotlesCalloutBlockDocxMapping(block.props),
    },
    inlineContentMapping: docxDefaultSchemaMappings.inlineContentMapping,
    styleMapping: docxDefaultSchemaMappings.styleMapping,
  },
  { colors: colorsWithCssFallback() },
);

export const StotlesPDFExporter = new PDFExporter(
  stotlesBlockNoteSchema,
  {
    blockMapping: {
      ...pdfDefaultSchemaMappings.blockMapping,
      // Add custom block mappings here if needed
      stotlesCallout: (block, _exporter, _nestingLevel, _numberedListIndex, _children) =>
        stotlesCalloutBlockPdfMapping(block.props),
    },
    inlineContentMapping: pdfDefaultSchemaMappings.inlineContentMapping,
    styleMapping: pdfDefaultSchemaMappings.styleMapping,
  },
  { colors: colorsWithCssFallback() },
);

export type StotlesPartialBlock = typeof stotlesBlockNoteSchema.PartialBlock;

export type StotlesBlock = typeof stotlesBlockNoteSchema.Block;

export type StotlesBlockNoteEditor = typeof stotlesBlockNoteSchema.BlockNoteEditor;
